import { Entity } from '@msdk/definitions'

import { useRoleLabel } from './useRoleLabel'

export const useSortedRoles = () => {
  const getRoleLabel = useRoleLabel()

  return (roles: Entity[]) => {
    return [...roles].sort((a, b) => {
      if (a.fields['GRP.ID']?.value && !b.fields['GRP.ID']?.value) {
        return 1
      }
      if (!a.fields['GRP.ID']?.value && b.fields['GRP.ID']?.value) {
        return -1
      }
      return getRoleLabel(a) > getRoleLabel(b) ? 1 : -1
    })
  }
}
